/**
 * Converts a string base64 encoded string back to utf8
 *
 * @param encoded - Base64 encoded string
 * @returns a decoded base64 string
 */
export function fromBase64(encoded: string): string {
    return Buffer.from(encoded, 'base64').toString('utf8');
}
